module.exports = __webpack_public_path__ + "img/logo.4f9d931a.svg";